import React from "react";
import { RegistrationStep } from "../types";

interface StepIndicatorProps {
  currentStep: RegistrationStep;
  totalSteps: number;
}

export const StepIndicator: React.FC<StepIndicatorProps> = ({
  currentStep,
  totalSteps,
}) => {
  const renderStep = (stepNumber: number) => {
    const isCompleted = currentStep > stepNumber;
    const isCurrent = currentStep === stepNumber;

    return (
      <div
        key={stepNumber}
        className={`flex items-center justify-center w-10 h-10 rounded-full ${
          isCompleted
            ? "bg-green-600 text-white"
            : isCurrent
            ? "bg-blue-600 text-white"
            : "bg-gray-300 text-gray-600"
        }`}
      >
        {isCompleted ? "✓" : stepNumber}
      </div>
    );
  };

  const renderConnector = (index: number) => {
    const isActive = currentStep > index + 1;
    return (
      <div
        key={`connector-${index}`}
        className={`w-24 h-1 ${
          isActive
            ? "bg-green-600"
            : currentStep === index + 2
            ? "bg-blue-600"
            : "bg-gray-300"
        }`}
      />
    );
  };

  return (
    <div className="flex items-center justify-center mb-6">
      <div className="flex items-center">
        {Array.from({ length: totalSteps }, (_, i) => i + 1).map(
          (stepNumber, index) => (
            <React.Fragment key={stepNumber}>
              {renderStep(stepNumber)}
              {index < totalSteps - 1 && renderConnector(index)}
            </React.Fragment>
          )
        )}
      </div>
    </div>
  );
};
